__webpack_require__.p = "/snippets/2024-01-06-strategic-life-thinking/app/";